import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CONTROLLERS, ENDPOINTS } from "../constants";
import { ApiService } from "./api.service";
import { Response } from '../models';
import { SettingDto, TTKeyVaultSecrets } from "../models/setting.model";

@Injectable({
  providedIn: 'root'
})
export class SettingService {
  private api: string = CONTROLLERS.TTINFOSETTING;

  constructor(private apiService: ApiService) {}

 getDefaultSetting(): Observable<Response<SettingDto>> {
    return this.apiService.get(
      `${this.api}/${ENDPOINTS.TTINFOSETTING.GET_DEFAULT}`
    );
  }

  getSecrets(): Observable<Response<TTKeyVaultSecrets>> {
    return this.apiService.get(
      `${this.api}/${ENDPOINTS.TTINFOSETTING.GET_SECRETS}`
    );
  }
 
}
